module.exports = __webpack_public_path__ + "img/image2.7f8fc2fe.png";